
export const updateShowRoom = (payload) => {
    return {
      type: 'ADD_SHOWROOM',
      payload
    };
  };
  